import classnames from 'classnames'

import IconButton from '../../../../../../../common/IconButton/IconButton'
import EditButton from '../../../../../components/EditButton/EditButton'
import GitHubIcon from '../../../../../svg/github.svg'
import PipelineRepositoryForm from '../PipelineRepositoryForm/PipelineRepositoryForm'

import type {PipelineRepositoryProps} from './PipelineRepository.types'
import usePipelineRepository from './usePipelineRepository'

import styles from './PipelineRepository.css'

function PipelineRepository({
  branch = '',
  branchSpec = '',
  repositoryUrl = '',
  isRoot = false,
  editMode = false,
  repositories = [],
  onDelete,
  onConfirm,
  onRestore,
  isDeleted = false,
  className,
}: PipelineRepositoryProps) {
  const {
    isEditMode,
    deleteRepositoryFormHandler,
    repositoryName,
    canEditable,
    canDeletable,
    canRestable,
    included,
    excluded,
    toggleEditModeHandler,
    addVcsRootHandler,
    deleteRepositoryHandler,
    branchSpecLabel,
  } = usePipelineRepository(
    branch,
    repositoryUrl,
    branchSpec,
    editMode,
    isDeleted,
    isRoot,
    onDelete,
    onConfirm,
  )
  const containerClassNames = classnames(className, styles.container, {[styles.deleted]: isDeleted})

  if (!isEditMode) {
    return (
      <div className={containerClassNames}>
        <GitHubIcon className={styles.icon} />
        <div
          role="presentation"
          onClick={toggleEditModeHandler(true)}
          className={styles.defaultBranch}
        >
          <div className={styles.repository}>
            <div>{repositoryName}</div>
            <span className={styles.branch}>{branch}</span>
            {branchSpecLabel && <div className={styles.branchRules}>{branchSpecLabel}</div>}
          </div>
          {canEditable && (
            <EditButton iconClassName={styles.editButtonIcon} className={styles.actionButton} />
          )}
        </div>
        <div>
          {canDeletable && (
            <IconButton
              className={styles.actionButton}
              icon={'trash'}
              title={'Delete'}
              aria-label={'Delete'}
              onClick={deleteRepositoryHandler}
            />
          )}
          {canRestable && (
            <IconButton
              className={styles.actionButton}
              icon={'update'}
              title={'Restore'}
              aria-label={'Restore'}
              onClick={onRestore}
            />
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={containerClassNames}>
      <PipelineRepositoryForm
        isRoot={isRoot}
        repositories={repositories}
        repositoryUrl={repositoryUrl}
        branch={branch}
        included={included}
        excluded={excluded}
        onDelete={deleteRepositoryFormHandler}
        onConfirm={addVcsRootHandler}
      />
    </div>
  )
}

export default PipelineRepository
